module.exports = __webpack_public_path__ + "img/ms_b2_pic3.df30073d.png";